import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import './plugins/iview' // 引入view-ui
import "./plugins/element"; // 引入element-ui
// import myEcharts from './plugins/echarts' // 引入echarts
// Vue.use(myEcharts) // 注册echarts
import "./vue_prototype";

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "../../assets/loading.gif",
  loading: "https://mp.bayou-tech.cn/app/loading.gif",
  attempt: 3
});
Vue.prototype.$img = "https://mp.bayou-tech.cn/";
// ————————————此处用于模拟sessionStorage————————start————————//
window.onload = function() {
  if (!window.sessionStorage.getItem("flag")) {
    // 浏览器关闭
    console.log("浏览器关闭");
    window.localStorage.clear(); // 清除缓存
  } else {
    // 浏览器刷新
    console.log("浏览器刷新");
  }
};

window.onunload = function() {
  window.sessionStorage.setItem("flag", true);
};

window.onbeforeunload = function() {
  window.sessionStorage.setItem("flag", true);
};
// ————————————此处用于模拟sessionStorage————————end————————//

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vue;
